export interface SocietyProviderDataForm {
    id?: number;
    society_id?: number;
    provider_id?: number;
    business_name_id?: number; // Para crear nuevo proveedor desde razón social
    is_active?: boolean;
    
    // Datos del proveedor (desde AllProviderSerializer)
    provider?: {
        id?: number;
        rut?: string;
        business_name?: {
            id?: number;
            name?: string;
            rut?: string;
            email?: string;
            phone_code?: string;
            phone?: string;
            address?: string;
        } | string; // Puede venir como objeto (SimpleBusinessNameSerializer) o string
        fantasy_name?: string;
        address?: string;
        country?: string;
        first_name_contact?: string;
        last_name_contact?: string;
        second_last_name_contact?: string;
        email_contact?: string;
        phone_code_contact?: string;
        phone_contact?: string;
        is_active?: boolean;
    };
    
    // Datos de la sociedad (desde AllSocietySerializer)
    society?: {
        id?: number;
        rut?: string;
        business_name?: string; // SerializerMethodField
        address?: string;
        country?: string;
        first_name_contact?: string;
        last_name_contact?: string;
        second_last_name_contact?: string;
        email_contact?: string;
        phone_code_contact?: string;
        phone_contact?: string;
        is_active?: boolean;
    };
}

export interface SocietyProviderFilters {
    society_id?: number; // Opcional: si es 0 o no está, lista todos
    name?: string;
    rut?: string; // Added for filtering
    business_name?: string; // Added for filtering
    fantasy_name?: string; // Added for filtering
    page: number;
    per_page: number;
    sort: string;
    order: string;
}

export const defaultSocietyProviderDataForm: SocietyProviderDataForm = {
    society_id: 0,
    is_active: true
};
